<template>
  <div class="cmp-product-group-matrix" v-if="render">

    <!------------------------------- MODAL --------------------------------->
    <utlz-static-modal v-if="showSpecsModal">
      <template v-slot:static-modal-content>
        <div class="product-specs-modal utlz-row">
          
          <span class="close-button">
            <i class="fa fa-times-circle" aria-hidden="true" @click="toggleSpecsModal()"></i>
          </span>

          <div class="utlz-col-12 flex-column align-center just-center">                          
            <div class="modal-header">
              <h3 v-translation="{ type: 'title', code: 'title_specifications' }"></h3>
            </div>

            <div class="modal-inner">

              <div class="prod-desc">
                <img :src="modalProduct.imageUrl ? modalProduct.imageUrl : '/documents/productimages/not-available-large.jpg'" />
                <div class="text-container">
                  <h3>{{ modalProduct.shortDescription }}</h3>
                  <div v-html="modalProduct.longDescription"></div>
                  <div class="spec-list">                                   
                    <div class="spec-item">
                      <div v-translation="{ code: 'label_product_code', type: 'label' }" class="spec-desc">
                      </div>
                      <div class="spec-value">
                        {{ modalProduct.id }}
                      </div>
                    </div>

                    <div class="spec-item" v-for="(key, index) in Object.keys(modalProduct.properties)" :key="'modal-prop-' + index">
                      <div class="spec-desc">               
                        {{ key }}           
                      </div>
                      <div class="spec-value">                          
                        {{ modalProduct.properties[key] }}
                      </div>
                    </div>                  
                  </div>
                </div>
              </div>                

            </div>
          </div>
        </div>
      </template>
    </utlz-static-modal>
    <!------------------------------- END MODAL --------------------------------->

      <!-- BESPOKE ROD: Added total properties col count as class for styling purposes  -->
      <div class="matrix"  :data-non-scrollable="properties.length < 4" :class="'total-col-' + properties.length">
      <!-- END BESPOKE ROD -->
        
        <!-- BESPOKE ROD: Added matrix header element -->
        <div id="matrix-header"></div>
        <!-- END BESPOKE ROD -->

          <div class="matrix-header">
              <div class="description">
                <span v-translation="{ type: 'label', code: 'label_matrix_header_product' }"></span>
              </div>

              <!-- BESPOKE ROD: Added properties column -->
              <div class="properties-header">
                <div class="scroll-btns">
                  <a class="square button left" @click="scroll('left')" >
                    <i class="fa fa-arrow-left"></i>
                  </a>
                  <a class="square button right" @click="scroll('right')" >
                    <i class="fa fa-arrow-right"></i>
                  </a>
                </div>
                <div class="properties-column">
                  <div class="properties" v-for="property in properties" v-bind:key="property" :data-col-id="property">
                      {{ property }}
                  </div>
                </div>
              </div>
              <!-- END BESPOKE ROD -->

              <div class="prod-details">
                <span v-translation="{ type: 'label', code: 'label_matrix_header_details' }"></span>
              </div>

              <div v-if="showPrices" class="prod-price">
                <span v-translation="{ type: 'label', code: 'label_matrix_header_price' }"></span>
              </div>

              <div v-if="showOrderProduct" class="prod-stock">
                <span v-translation="{ type: 'label', code: 'label_stock_indicator' }"></span>
              </div>
              <div class="order"></div>
          </div>
          <div class="matrix-row" v-for="variant in variants" v-bind:key="variant.id">
            
              <a :href="variant.targetUrl">
                <div class="description">
                  <!-- BESPOKE: Added product image and wrapper -->
                    <img :src="variant.imageUrl" :alt="variant.imageAltText" class="row-prod-img"  />
                    <div class="desc-wrapper">
                      <span class="prod-code">{{ variant.id }}</span>
                      <span class="prod-desc">{{ variant.shortDescription }}</span>
                    </div>
                </div>
              </a>
              <!-- BESPOKE ROD: Added properties column -->
              <div class="properties-column">
                <div class="gradient grad-left"></div>
                <div class="properties" v-for="property in properties" v-bind:key="property" :data-col-id="property">
                  {{variant.properties[property]}}
                </div>
              </div>
              <!-- END BESPOKE ROD -->

              <!-- BESPOKE ROD: Added coumn details -->
              <div class="prod-details">                
                <div class="gradient grad-right"></div>
                <i @click="toggleSpecsModal(variant)" class="fa fa-info-circle"></i>
              </div>
              <!-- END BESPOKE ROD -->

              <div class="prod-price">
                <div class="ph-product-price" v-if="variant.prices.length">
                  <utlz-product-price
                    :prices="variant.prices[0]"
                  ></utlz-product-price>
                </div>
              </div>

              <!-- BESPOKE ROD: Added :showIndicatorLabel -->
              <div v-if="showStock" class="prod-stock">
                <utlz-product-stock
                  :stock="variant.stock"
                  :stockTotal="variant.stock"
                  :showIndicatorLabel="false"
                ></utlz-product-stock>
              </div>
              <!-- END BESPOKE ROD -->

              <div class="order">
                <!-- BESPOKE ROD: 
                  - Changed allowZeroQuantity to false
                  - Added userOrderMode=orderIndividualLines so each orderline may be ordered individually if needed -->
                <utlz-order-product
                  v-if="showOrderProduct"
                  :product="variant"
                  :allowZeroQuantity="orderIndividualLines === false"
                  :useOrderMode="orderIndividualLines"
                  @quantityChanged="quantityChanged($event, variant)"
                  @unitsChanged="unitsChanged($event, variant)"
                ></utlz-order-product>
                <!-- END BESPOKE ROD -->
              </div>

          </div>
      </div>
      <!-- BESPOKE ROD: Added !orderIndividualLines and added #matrix-order-btn -->
      <div v-if="showOrderProduct && !orderIndividualLines" id="matrix-order-btn" class="order-product-btn flex-row-nowrap justify-content-end">
        <a
          @click="addOrderLinesToCart()"
          class="button large theme-primary btn-orange"
          :class="{ 'disabled': !orderLines.length }">
          <!-- BESPOKE ROD: Added shoppingcart icon and a total counter -->
          <span class="material-icons-outlined">shopping_cart</span>
          <span v-translation="{ type: 'button', code: 'button_order' }"></span>
          <span class="matrix-counter">{{ matrixTotals }}</span>
          <!-- END BESPOKE ROD -->
          </a>
      </div>
      <!-- END BESPOKE ROD -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OrderProduct from 'src/components/webshop/order-product/OrderProduct.vue';
import ProductPrice from 'src/components/webshop/product-price/ProductPrice.vue';
import ProductStock from 'src/components/webshop/product-stock/ProductStock.vue';
// BESPOKE ROD
import StaticModal from 'src/components/ui/static-modal/StaticModal.vue';
// END BESPOKE ROD

export default {
  components: {
    'utlz-order-product': OrderProduct,
    'utlz-product-price': ProductPrice,
    'utlz-product-stock': ProductStock,    
    // BESPOKE ROD
    'utlz-static-modal': StaticModal
    // END BESPOKE ROD
  },
  props: {
    variants: { type: Array, required: true },
    // BESPOKE ROD
    // Added property so matrix lines can be ordered individually if needed
    orderIndividualLines: { type: Boolean, required: false, default: false }
    // END BESPOKE ROD
  },
  data () {
    return {
      orderLines: [],
      render: true,
      // BESPOKE
      showSpecsModal: false,
      columnsComputed: false
      // END BESPOKE
    }
  },
  computed: {
    ...mapGetters(['showStock', 'userLoggedOn', 'showOrderProduct', 'showPrices']),
    properties () {
      if (this.variants.length > 0) {
        return Object.keys(this.variants[0].properties);
      }
      return [];
    },
    // BESPOKE ROD
    matrixTotals () {
      let totals = 0;
      this.orderLines.forEach(line => {
        totals += line.ord_qty;
      });
      return totals;
    }
    // END BESPOKE ROD
  },
  methods: {
    quantityChanged ({ computedQuantity, unitCode }, variant) {
      // BESPOKE ROD
      // Mapped orderline to a new array first, and assignging the array this.orderLines after, 
      // since detecting change on this.orderLines was creating an issue on the .matrixTotals property
      const newOrderLines = [...this.orderLines];
      const index = newOrderLines.findIndex(orderLine => orderLine.prod_code === variant.id);
      if (computedQuantity !== 0) {
        if (index === -1) {
          newOrderLines.push({
            prod_code: variant.id,
            ord_qty: computedQuantity,
            unit_code: unitCode,
            prod_comment: ''
          });
        } else if (index > -1) {
          newOrderLines[index] = {
            prod_code: variant.id,
            ord_qty: computedQuantity,
            unit_code: unitCode,
            prod_comment: ''
          };
        }
      } else if (computedQuantity === 0 && index >= 0) {
        newOrderLines.splice(index, 1);
      }
      this.orderLines = newOrderLines;
      // END BESPOKE ROD
    },
    unitsChanged ({ unitCode, quantity, computedQuantity }, variant) {
      // Changing units resets quantity buttons to zero, so delete variant from orderLines
      const index = this.orderLines.findIndex(orderLine => orderLine.prod_code === variant.id);
      if (index > -1) {
        this.orderLines.splice(index, 1);
      }
    },
    addOrderLinesToCart () {
      this.addToCart(this.orderLines)
        .then(res => {
          this.render = false;
          this.$nextTick(() => {
            this.render = true;
            this.orderLines = [];
          });
        });
    },
    scroll (direction) {
      const scrollContainers = document.querySelectorAll('.properties-column');
      scrollContainers.forEach(function(el) {
        
        if (direction === 'left') {
        el.scrollBy({
          left: -10,
          behavior: 'smooth'
        })
        } else if (direction === 'right') {
          el.scrollBy({
            left: el.scrollLeft + 10,
            behavior: 'smooth'
          })
        }
      });
      // setTimeout(() => {
      //   this.showControlLeft = scrollContainer.scrollLeft > 0;
      //   this.showControlRight = scrollContainer.offsetWidth + scrollContainer.scrollLeft !== scrollContainer.scrollWidth;
      // }, 350)
    },
    toggleSpecsModal (product) {
      if (this.showSpecsModal) {
        this.modalProduct = {};
      } else {
        this.modalProduct = product;
      }
      this.showSpecsModal = !this.showSpecsModal;
    },
    handleScroll () {
      let mobileAnchor = document.getElementById('matrix-header');
      if (mobileAnchor) {
        let positions = mobileAnchor.getBoundingClientRect();
        if (positions.top < $(window).height()) {
          $('#matrix-order-btn').addClass('sticky');
        } else {
          $('#matrix-order-btn').removeClass('sticky');
        }
      }    
    },
    ...mapActions('shoppingCart', ['addToCart'])
  },
  // BESPOKE
  created () {
    $(window).scroll(()=> {    
      this.handleScroll();
    });
  },
  mounted () {
  },
  updated () {
    if (!this.columnsComputed) {
      if ($('.matrix-row:first .properties').length) {
        $('.matrix-row:first .properties').each(function () {
          let height = Math.ceil($(this).height() / 35);
          if (height > 1) {
           $('.matrix').find('[data-col-id="'+ $(this).data('col-id')+ '"]').addClass('col-width-' + height)
          }
        });
        this.columnsComputed = true;
      }      
    }
  }
}
</script>

<style>

</style>
